export enum ClassificationStatus {
    REVIEWED = 1,
    PENDING_REVIEW = 2,
    PENDING_CORRECTION = 3,
    REMOVED = 4
}
